export default {
  year: '年',
  month: '月',
  day: '日',
  hour: '时',
  minute: '分',
  am: '上午',
  pm: '下午'
}



// WEBPACK FOOTER //
// ./src/components/mobile-date-picker/locale/zh_CN.js